import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Message } from "primereact/message";
import { forwardRef, useImperativeHandle, useState } from "react";
import NewCandidateForm from "../components/CandidateForm";

const AddNewRegistration = forwardRef((props, ref) => {
  const [active, setActive] = useState(false);
  const [newStudent, setNewStudent] = useState({
    lastname: "",
    firstname: "",
    gender: "",
    birthday: "",
    postal_code: "",
    authorized_back_alone: false,
    authorized_back_with: "",
    authorized_take_photo: false,
    health_issues: "",
    medical_traitement: "",
    allergies: "",
    medical_devices: "",
    parents_divorced: false,
    registration_details: "",
    accepted_internal_rules: true,
  });
  //
  useImperativeHandle(ref, () => ({
    show: () => {
      setActive(true);
      setNewStudent({
        lastname: "",
        firstname: "",
        gender: "",
        birthday: "",
        email: "",
        phone: "",
        postal_code: "",
        authorized_back_alone: false,
        authorized_back_with: "",
        authorized_take_photo: false,
        health_issues: "",
        medical_traitement: "",
        allergies: "",
        medical_devices: "",
        parents_divorced: false,
        registration_details: "",
        accepted_internal_rules: true,
      });
    }
  }));

  const handleSubmit = () => {
    setActive(false);
    props.callbackHandler?.(newStudent);
  };

  return (
    <>
      <Dialog
        header="Ajouter une nouvelle inscription"
        visible={active}
        onHide={() => setActive(false)}
        maximizable
        modal
        style={{ width: '90vw', height: '90vh' }}
        footer={<Button size="large" label="Envoyer la candidature" disabled={!newStudent?.lastname || !newStudent?.firstname || !newStudent?.gender || !newStudent?.birthday} icon="pi pi-send" onClick={handleSubmit} />}
      >
        <div>
          <Message severity="warn" text="Veuillez noter que la candidature sera traitée par l'administration et vous serez informé de l'issue." className="mt-3" />
        </div>
        <NewCandidateForm student={newStudent} setStudent={setNewStudent} father={props?.father} mother={props?.mother} school={props?.school} training={props?.training} />
      </Dialog>
    </>
  );
});

export default AddNewRegistration;